import * as React from 'react';
import { Repeat2Icon } from 'lucide-react';
import { cn } from 'lib/utils';

export const ReturnStatusIcon = () => {
  return (
    <div title={'Devolução'} className={cn(
      'flex items-center justify-center',
      'rounded-full w-6 h-6 bg-red-500',
    )}>
      <Repeat2Icon className={'w-4 h-4 stroke-slate-50'} />
    </div>
  );
};